import { useContext, useState } from 'react'
import { CreateProjectDispatch } from './create-project'
import ProjectTypeButton from './project-type-button'

import OverlappingIcon from '../../../images/OverlappingUpload.svg'
import GeoTIFFIcon from '../../../images/GeoTIFFUpload.svg'
import FilePicker from './file-picker'

import PropTypes from 'prop-types'

export default function ChooseFiles({ projectType }) {
  const [files, setFiles] = useState([])
  const dispatch = useContext(CreateProjectDispatch)

  const chooseFiles = type => {
    setFiles([])
    dispatch({ type: 'SET_PROJECT_TYPE', payload: type })
  }

  return (
    <div className="tw-m-auto tw-max-w-6xl">
      <div className="tw-p-8">
        <h1 className="tw-text-center tw-text-2xl tw-text-system-grey-400 tw-custom-uppercase tw-mb-8">
          Choose what type of images you would like to upload
        </h1>
        <div className="tw-m-auto">
          {projectType && (
            <FilePicker
              multiple={projectType !== 'geotiff'}
              accept={
                projectType !== 'geotiff'
                  ? '.tif, .tiff, .jpg, .jpeg'
                  : '.tif, .tiff'
              }
              onChange={files =>
                dispatch({ type: 'UPDATE_FILES', payload: files })
              }
              value={files}
            />
          )}
          <div className="tw-flex tw-justify-around tw-flex-wrap">
            <ProjectTypeButton
              title="Overlapping Images"
              description="Images collected with front and side overlap with the purpose of creating an orthomosaic, elevation map, plant health map and prescription."
              onClick={() => chooseFiles('overlapping')}>
              <OverlappingIcon />
            </ProjectTypeButton>
            <ProjectTypeButton
              title="Stitched Map"
              description="Import a stitched map (GeoTIFF) from other tools, to generate plant health map, prescription and more."
              onClick={() => chooseFiles('geotiff')}>
              <GeoTIFFIcon />
            </ProjectTypeButton>
          </div>
        </div>
      </div>
    </div>
  )
}

ChooseFiles.propTypes = {
  projectType: PropTypes.string,
}
